const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';

export function receiveMessage(topic, payload) {
  return {
    type: RECEIVE_MESSAGE,
    message: {
      payload,
      topic
    }
  }
}

export default (state = {
  messages: []
}, action) => {
  switch (action.type) {
    case RECEIVE_MESSAGE:
      return {
        ...state,
        messages: state.messages.concat(action.message)
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/mqtt.js